import React from 'react';
import PromoCodeForm from '../../../../components/SiteAdmin/PromoCode/PromoCodeForm';

class AddPromoCode extends React.Component {
  render() {
    return (
      <PromoCodeForm initialValues={{ type: 2, maxUses: 4, currency: 'USD' }} />
    );
  }
}

export default AddPromoCode;